import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'SpecialColumnArticleRelation',
    column_type: 'id',
  },
  created_at: {
    model_name: 'SpecialColumnArticleRelation',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'SpecialColumnArticleRelation',
    column_type: 'datetime',
  },
  position: {
    model_name: 'SpecialColumnArticleRelation',
    column_type: 'integer',
  },
  article: {
    model_name: 'SpecialColumnArticleRelation',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'article',
      model_name: 'Article',
      foreign_key: 'article_id',
    },
  },
  article_id: {
    model_name: 'SpecialColumnArticleRelation',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'article',
      model_name: 'Article',
      foreign_key: 'article_id',
    },
  },
}

export const columnsExtend = (columns, { filterColumnsExtend } = {}) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns, filterColumnsExtend)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
